export default "__VITE_ASSET__ffbef333__"